import type { StaffTeamRole } from "@lafayette/schemas";

// The words of the team, coverage and support screens. The API answers with closed codes; every word a person reads is here.

export const roleLabels: Readonly<Record<StaffTeamRole, string>> = {
  concierge: "Concierge",
  supervisor: "Supervisor",
  catalog_editor: "Catalog editor",
  administrator: "Administrator",
};

/** What a role lets a person do, in one plain sentence: the access review reads this. */
export const roleDescriptions: Readonly<Record<StaffTeamRole, string>> = {
  concierge:
    "Works with the customers assigned to them: conversations, requests, memory. Sees no other customer.",
  supervisor:
    "Sees every customer and runs the cover: assignments, unavailability, coverage gaps. Cannot change roles.",
  catalog_editor: "Edits and publishes the catalog and runs imports. Sees no customer data.",
  administrator:
    "Manages staff accounts and roles. Sees no customer data. May refund by payment id.",
};

export const roleOrder: readonly StaffTeamRole[] = [
  "concierge",
  "supervisor",
  "catalog_editor",
  "administrator",
];

export const statusLabels = { ACTIVE: "Active", DEACTIVATED: "Offboarded" } as const;

export const assignmentTypeLabels = {
  PRIMARY: "Primary",
  BACKUP: "Backup",
  TEMPORARY: "Temporary",
} as const;

export const assignmentTypeHints = {
  PRIMARY: "The concierge who owns this customer.",
  BACKUP: "Takes the work when the primary is not available.",
  TEMPORARY: "Covers for a set time. It never changes the primary.",
} as const;

export const availabilityReasonLabels = {
  ON_LEAVE: "On leave",
  OFF_SHIFT: "Off shift",
  SICK: "Sick",
  TRAINING: "Training",
  OTHER: "Other",
} as const;

export const gapKindLabels = {
  UNASSIGNED_HANDOFF: "A customer waits for a person and nobody can take it",
  CUSTOMER_WITHOUT_PRIMARY: "The customer has no primary concierge",
  PRIMARY_UNAVAILABLE: "The primary is not available and nobody covers",
} as const;

export const gapKindShort = {
  UNASSIGNED_HANDOFF: "Handoff nobody can take",
  CUSTOMER_WITHOUT_PRIMARY: "No primary",
  PRIMARY_UNAVAILABLE: "Primary unavailable",
} as const;

export const conversationModeLabels: Readonly<Record<string, string>> = {
  AI_ACTIVE: "The AI concierge is answering",
  WAITING_FOR_CONCIERGE: "Waiting for a person",
  HUMAN_ACTIVE: "A person is answering",
};

export const activityKindLabels = {
  request: "Request",
  payment: "Payment",
  handoff: "Handoff",
  trip: "Trip",
} as const;

export const handoffStatusLabels: Readonly<Record<string, string>> = {
  WAITING: "Waiting for a person",
  ACCEPTED: "Taken by a person",
};
